import { LABEL_TEXT_POSITION } from '../types/default.js';

/**
 * Returns the text anchor position for a label based on its coordinates.
 * @param labelX - The x coordinate of the label
 * @param labelY - The y-coordinate of the label
 * @returns The text anchor position ('start' or 'end')
 */
export const getLabelTextAnchor = (labelX: number, labelY: number): string => {
  const topLeft = labelX < 0 && labelY > 0;
  const bottomLeft = labelX < 0 && labelY < 0;

  if (bottomLeft || topLeft) {
    return LABEL_TEXT_POSITION.END;
  }

  return LABEL_TEXT_POSITION.START;
};
